import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
// Locale packs for every supported language (config.js supportedLanguages).
// dayjs keys locales by base language, so `pt-PT` uses `pt`, `es-ES` uses `es`.
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';

dayjs.extend(relativeTime);

const formatTimestamp = (timestamp, language = 'en') => {
  const locale = language.split('-')[0].toLowerCase();
  const date = timestamp.toDate();
  const dayjsDate = dayjs(date).locale(locale);
  let relativeTimeString = dayjsDate.fromNow();
  // English-only quirk fix: dayjs says "a day ago" where the design wants "1 day ago"
  if (locale === 'en' && relativeTimeString === 'a day ago') {
    relativeTimeString = '1 day ago';
  }
  return relativeTimeString;
};

export default formatTimestamp;
